export default __webpack_public_path__ + "static/media/up_arrow.54ad45dd.svg";